import { useEffect, useState } from "react";
import { HttpStatusCode } from "axios";

import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";

import { ActionsKey } from "../../../common/models/Actions";
import { ColumnItem } from "../../../common/models/table";
import {
  useOperationFeature,
  useOperationFeatureStore,
} from "../store/DashboardStore";
import { DashboardService } from "../core/_request";

import { API_BASE_URL_IMAGE } from "../../../utilities/API_CONSTANT";
import { Assets } from "../../../assets";

const FeatureOperation = () => {
  const { setStorageList, storageList, totalItems, setActioned } =
    useOperationFeatureStore();
  const { pageState, setPageState, resetPageState } = useOperationFeature();

  const cols: ColumnItem[] = [
    {
      title: "",
      dataIndex: "customer",
      key: "customer.image",
      show: true,
      render: (url: any) => (
        <img
          src={
            url?.image?.contentUrl
              ? API_BASE_URL_IMAGE + url.image.contentUrl
              : Assets.images.entreprise
          }
          alt="photo"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
    {
      key: "customer.name",
      title: "Entreprise",
      dataIndex: "customer",
      show: true,
      isCanSort: true,
      render: (value: any) => {
        return <span>{value?.name}</span>;
      },
    },
    {
      key: "customer.reference",
      title: "Code client",
      dataIndex: "customer",
      show: true,
      isCanSort: true,
      render: (value: any) => {
        return <span>{value?.reference}</span>;
      },
    },
    {
      key: "operationType.name",
      title: "Opérations",
      dataIndex: "operationType",
      show: true,
      isCanSort: true,
      render: (value: any) => {
        return <span>{value?.name}</span>;
      },
    },
    {
      key: "estimatedArrivalAt",
      title: "Temps estimé d’arrivée",
      dataIndex: "estimatedArrivalAt",
      show: true,
      isCanSort: true,
    },
  ];

  useEffect(() => {
    fetchAllFeatureOperation(pageState);
  }, [pageState]);

  const onActionClick = (item: any, action: ActionsKey) => {
    console.log("Action clicked:", action, item);
  };

  const fetchAllFeatureOperation = async (params?: any) => {
    try {
      const res = await DashboardService.getOperationFeatureList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setStorageList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="p-4">
      <div className="">
        <p style={{ color: "#677788" }}>Liste des opérations futures</p>
        <div className="">
          <LFTableV3
            columns={cols}
            data={storageList}
            params={pageState}
            onAction={onActionClick}
            onSearch={handleSetParams}
            onSort={handleSetParams}
            onResetSearch={resetPageState}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
            onChangePage={handleSetParams}
          />
        </div>
      </div>
    </div>
  );
};

export default FeatureOperation;
